<template>
  <div class="login-form">
    <div class="mdl-card mdl-shadow--2dp" v-if="state=='reset' || state=='resent'">
      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">{{ i18n()[state].title }}</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand loading">
        <p>{{ i18n()[state].text({email}) }}</p>
      </div>
    </div>

    <div class="mdl-card mdl-shadow--2dp" v-if="state != 'reset' && state != 'resent'">
      <div class="mdl-card__title mdl-card-colo">
        <h2 class="mdl-card__title-text">{{ i18n().title }}</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand">

        <div class="error" v-if="error">
          <span v-if="error">{{ i18n().errors[error] || error }}</span>
          <a href="#" @click="resetPassword" v-if="error == 'wrongPassword'">{{ i18n().resetButton }}</a>
          <a href="#" @click="resend" v-if="error == 'registrationNotConfirmed'">{{ i18n().resendButton }}</a>
        </div>

        <form v-on:submit="login" v-bind:class="{ blurred: state == 'working' }">

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="email" id="email" v-model="email"
                   v-bind:required="required" ref="email">
            <label class="mdl-textfield__label" for="email">{{ i18n().email }}</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="password" id="password" v-model="password"
                   v-bind:required="required" ref="password">
            <label class="mdl-textfield__label" for="password">{{ i18n().password }}</label>
          </div>

          <button class="mdl-button mdl-js-button mdl-button--raised" type="submit">
            {{ i18n().submit }}
          </button>

        </form>

        <p>{{ i18n().registerText }} <router-link :to="{name: 'register'}">{{ i18n().registerLink }}</router-link></p>

        <div class="working" v-if="state == 'working'">
          <div class="mdl-spinner mdl-js-spinner is-active"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import i18n from "i18n"
  import api from "api"
  import logger from 'logger'

  export default {
    name: 'login-form',
    metaInfo: {
      title: i18n().emailPassword.loginForm.title
    },
    data () {
      return {
        state: "ready",
        error: null,
        email: "",
        password: "",
        required: false,
      }
    },
    methods: {
      i18n() { return i18n().emailPassword.loginForm },
      login(e) {
        e.preventDefault()

        if(this.email.trim()=='' || this.password.trim()=='') {
          this.required = true
          if(this.email.trim()=='') {
            this.$refs.email.parentElement.setAttribute('class',
              this.$refs.email.parentElement.getAttribute('class')+' is-invalid')
            this.$refs.email.focus()
          }
          if(this.password.trim()=='') {
            this.$refs.password.parentElement.setAttribute('class',
              this.$refs.password.parentElement.getAttribute('class')+' is-invalid')
            this.$refs.password.focus()
          }
          return
        }

        this.state = "working"
        let password = this.password
        logger.addPassword(password)
        api.request(["emailPassword", "login"], this.email, password).then(result => {
          logger.removePassword(password)
          this.state = "done"
        }).catch(error => {
          logger.removePassword(password)
          this.error = error
          this.state = "ready"
          if(error == 'notFound') {
            this.$refs.email.parentElement.setAttribute('class',
              this.$refs.email.parentElement.getAttribute('class')+' is-invalid')
            this.$refs.email.focus()
          }
          if(error == 'wrongPassword') {
            this.$refs.password.parentElement.setAttribute('class',
              this.$refs.password.parentElement.getAttribute('class')+' is-invalid')
            this.$refs.password.focus()
          }
        })
      },
      resetPassword(e) {
        e.preventDefault()

        this.state = "working"
        api.request(["emailPassword", "startPasswordReset"], this.email).then(result => {
          this.state = "reset"
        }).catch(error => {
          this.error = error
          this.state = "ready"
          if (error == 'notFound') {
            this.$refs.email.parentElement.setAttribute('class',
              this.$refs.email.parentElement.getAttribute('class') + ' is-invalid')
            this.$refs.email.focus()
          }
        })
      },
      resend(e) {
        e.preventDefault()

        this.state = "working"
        api.request(["emailPassword", "resendRegisterKey", this.email], this.email).then(result => {
          this.state = "resent"
        }).catch(error => {
          this.error = error
          this.state = "ready"
          if (error == 'notFound') {
            this.$refs.email.parentElement.setAttribute('class',
              this.$refs.email.parentElement.getAttribute('class') + ' is-invalid')
            this.$refs.email.focus()
          }
        })
      }
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
      window.lfvm = this
    }
  }
</script>

<style scoped>

  .login-form {
    display: flex;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: url(../../../static/images/voleadstools2.png);
    background-position: center;
    background-size: 280%;
  }

  .mdl-card {
    width: 320px;
    margin: auto;
  }
  .mdl-card__title {
    height: 110px;
    color: #fff;
    background: url(../../../static/images/voleadstools2_mid.png) 215px 5px no-repeat #241d7f;
    background-size: 100px;
  }

  button {
    background: #1d0585;
    color: white;
    font-weight: 300;
    float: right;
  }

  button:hover {
    background: #2906bf;
    color: white;
    font-weight: 300;
  }

  .mdl-card__supporting-text {
    position: relative;
  }

  form.blurred {
    filter: blur(2px);
  }

  .working {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    text-align: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
  }
  .working div {
    margin: auto;
    height: 5em;
    width: 5em;
  }

  .error {
    height: 3em;
    font-size: 1.23em;
    color: #d00000;
  }


</style>



// WEBPACK FOOTER //
// LoginForm.vue?41f624ee